import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8a4b748d-a67a-4760-b635-c7f9b7921d7e/artifacts/kn8679bx_Feral%20Ways%20Logo.png";

const navigationLinks = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'Mapping', path: '/mapping' },
  { name: 'Projects', path: '/projects' },
  { name: 'About', path: '/about' },
  { name: 'Store', path: '/store' },
  { name: 'Contact', path: '/contact' },
];

export const Footer = () => {
  return (
    <footer className="bg-forest text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand Column */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="F.E.R.A.Lways" 
                className="h-14 w-14 object-contain bg-white rounded-full p-1"
              />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Ecological landscape design rooted in nature. Regenerative design for farms, communities, and homesteads in Karnataka and South India.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-serif text-lg mb-6">Navigation</h4>
            <ul className="space-y-3">
              {navigationLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/70 hover:text-white transition-colors text-sm"
                    data-testid={`footer-nav-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-white/50 flex-shrink-0 mt-0.5" />
                <span className="text-white/70 text-sm">
                  Sakleshpura, Karnataka<br />India
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-white/50 flex-shrink-0" />
                <a 
                  href="tel:+919606591592" 
                  className="text-white/70 hover:text-white transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  +91 9606591592
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-white/50 flex-shrink-0" />
                <a 
                  href="mailto:reachout@feralways.org" 
                  className="text-white/70 hover:text-white transition-colors text-sm"
                  data-testid="footer-email"
                >
                  reachout@feralways.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              &copy; {new Date().getFullYear()} F.E.R.A.Lways. All rights reserved.
            </p>
            <p className="text-white/50 text-sm">
              Forest Ecology Regenerative Agriculture & Livelihoods
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
